import {
  CloseCircleOutlined,
  FilterOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { AutoComplete, Button, Flex, Form, Input, Select, Space } from 'antd';
import { useEffect } from 'react';

import { useCitiesAutocomplete } from '@pages/Organizations/OrganizationsList/hooks/useCitiesAutocomplete';
import { useCountriesSelect } from '@pages/Organizations/OrganizationsList/hooks/useCountriesSelect';
import { useFilterForm } from '@pages/Organizations/OrganizationsList/hooks/useFilterForm';

import type { OrganizationsFilterFormValues } from '@pages/Organizations/OrganizationsList/Organizations.types';

import type { FC } from 'react';

type OrganizationsFilterFormProps = {
  onChange: (values: OrganizationsFilterFormValues | undefined) => void;
};

export const OrganizationsFilterForm: FC<OrganizationsFilterFormProps> = ({
  onChange,
}) => {
  const [form] = Form.useForm();

  const { countries } = useCountriesSelect();
  const { cities, changeCity, selectCity } = useCitiesAutocomplete();

  const { rules, values, submit, reset } = useFilterForm();

  useEffect(() => {
    onChange(values);
  }, [onChange, values]);

  return (
    <Form
      form={form}
      onFinish={submit}
      layout="vertical"
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 30 }}
    >
      <Form.Item name="term" rules={rules.term} className="filter-term">
        <Input
          placeholder="Поиск (по названию, ИНН, КПП, ID, представитель, телефон)"
          addonBefore={<SearchOutlined />}
          data-testid="search-organization"
        />
      </Form.Item>
      <Form.Item>
        <Flex wrap align="center" justify="space-between" gap={24}>
          <div className="filters-wrapper">
            <Form.Item name="countryId" className="filter-countries">
              <Select
                options={countries}
                size="middle"
                placeholder="Все страны"
                className="country-select"
                popupRender={(menu) => (
                  <div data-testid="country-dropdown">{menu}</div>
                )}
                optionRender={(option) => (
                  <span data-testid="country-item">{option.label}</span>
                )}
              />
            </Form.Item>

            <Form.Item name="city" className="filter-city">
              <AutoComplete
                options={cities}
                onSearch={changeCity}
                onSelect={selectCity}
                placeholder="Начните вводить город"
                className="city-autocomplete"
              />
            </Form.Item>
          </div>

          <Space size="middle" className="filter-buttons">
            <Button
              htmlType="reset"
              onClick={reset}
              data-testid="reset-filters"
            >
              <CloseCircleOutlined />
              Сброс
            </Button>

            <Button
              type="primary"
              htmlType="submit"
              data-testid="search-by-filters"
            >
              <FilterOutlined />
              Поиск
            </Button>
          </Space>
        </Flex>
      </Form.Item>
    </Form>
  );
};
